<template>
  <v-container fluid grid-list-md>
    <v-layout>
      <v-flex d-block>
        <p class="text-xs-right">Updated with data at {{lastUpdatedDate}}</p>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex d-block xs12 md6>
        <h3>Activity by date</h3>
        <div class="filters">
          <div class="filter-item">
            <v-menu full-width offset-y :close-on-content-click="false" bottom>
              <div slot="activator">
                <v-btn color="primary" class="date-picker-from" small>{{ dashboard.activityByDate.filters.fromDate }}</v-btn> &dash;
                <v-btn color="primary" class="date-picker-to" small>{{ dashboard.activityByDate.filters.toDate }}</v-btn>
              </div>
              <v-card>
                <v-card-text>
                  <v-daterange :options="activityByDateOptions"
                               @input="handleActivityByDateChange"
                               no-presets/>
                </v-card-text>
              </v-card>
            </v-menu>
          </div>
          <div class="filter-item ml-2">
            <v-select
              class="origin-type-selector"
              :items="dashboard.availableOriginTypes"
              v-model="activityByDateOriginType"
              item-value="value"
              item-text="title"
            />
          </div>
        </div>
        <bar-chart :chartData="activityByDateBarData" :height="300" chart-id="1" :options="optionsBar"></bar-chart>
      </v-flex>
      <v-flex d-block xs12 md6>
        <h3>Reports by Case Creation Date</h3>
        <div class="filters">
          <div class="filter-item">
            <v-menu full-width offset-y :close-on-content-click="false" bottom>
              <div slot="activator">
                <v-btn color="primary" class="date-picker-from" small>{{ dashboard.reportsByDate.filters.fromDate }}</v-btn> &dash;
                <v-btn color="primary" class="date-picker-to" small>{{ dashboard.reportsByDate.filters.toDate }}</v-btn>
              </div>
              <v-card>
                <v-card-text>
                  <v-daterange :options="reportsByDateOptions"
                               @input="handleReportsByDateChange"
                               no-presets/>
                </v-card-text>
              </v-card>
            </v-menu>
          </div>
          <div class="filter-item ml-2">
            <v-select
              class="origin-type-selector"
              :items="dashboard.availableOriginTypes"
              v-model="reportsByDateOriginType"
              item-value="value"
              item-text="title"
            />
          </div>
        </div>
        <bar-chart :chartData="reportsByDateBarData" :height="300" chart-id="1" :options="optionsBar"></bar-chart>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex d-block xs12 md12>
        <h3>Cases vs materials</h3>
        <cases-vs-materials :data="dashboard.casesVsMaterials.data" :loading="dashboard.casesVsMaterials.inProgress" class="mt-2"></cases-vs-materials>
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script>
import BarChart from './Charts/Bar'
import DialogDatePicker from './Fields/DialogDatePicker'
import Countdown from './Countdown'
import SpecialistsInitials from './SpecialistsInitials'
import CasesVsMaterials from './Dashboard/CasesVsMaterials'
import DateWithMinutes from './Filters/DateWithMinutes.js'
import NoEmpty from './Filters/NoEmpty.js'
import api from '../api'
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import 'moment-duration-format'

export default {
  name: 'Dashboard',
  components: {
    BarChart,
    DialogDatePicker,
    Countdown,
    SpecialistsInitials,
    CasesVsMaterials
  },
  filters: {
    DateWithMinutes,
    NoEmpty
  },
  data () {
    return {
      lastUpdatedDate: 'N/A',
      activityByDateOptions: {
        startDate: moment().subtract(14, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        format: 'YYYY-MM-DD'
      },
      reportsByDateOptions: {
        startDate: moment().subtract(14, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        format: 'YYYY-MM-DD'
      },
      optionsBar: {
        responsive: true,
        maintainAspectRatio: false,
        scales:
          {
            yAxes: [
              {
                ticks:
                  {
                    beginAtZero: true
                  }
              }]
          }
      }
    }
  },
  computed: {
    ...mapState({
      dashboard: 'dashboard'
    }),
    activityByDateOriginType: {
      get () {
        return this.dashboard.activityByDate.filters.originType
      },
      set (value) {
        this.dashboardChangeABDCaseOrigin(value)
      }
    },
    reportsByDateOriginType: {
      get () {
        return this.dashboard.reportsByDate.filters.originType
      },
      set (value) {
        this.dashboardChangeRBDCaseOrigin(value)
      }
    },
    activityByDateBarData () {
      return {
        labels: this.dashboard.activityByDate.data.labels,
        datasets: [
          {
            label: 'Case created',
            backgroundColor: '#29B6F6',
            data: this.dashboard.activityByDate.data.createdByDate
          },
          {
            label: 'Case validated',
            backgroundColor: '#01579B',
            data: this.dashboard.activityByDate.data.validatedByDate
          }
        ]
      }
    },
    reportsByDateBarData () {
      return {
        labels: this.dashboard.reportsByDate.data.labels,
        datasets: [
          {
            label: 'Reports',
            backgroundColor: '#29B6F6',
            data: this.dashboard.reportsByDate.data.validatedByCreationDate
          },
          {
            label: 'Reports Overdue',
            backgroundColor: '#01579B',
            data: this.dashboard.reportsByDate.data.overduedByCreationDate
          }
        ]
      }
    }
  },
  beforeCreate () {
    if (!this.$store.state.isLogged) {
      this.$router.push({ name: 'Login' })
    }
  },
  watch: {

  },
  mounted () {
    this.getMccLastUpdatedDate()
    this.loadABD()
    this.loadRBD()
    this.loadCasesVsMaterials()
  },
  methods: {
    ...mapActions({
      loadABD: 'loadABD',
      dashboardChangeABDDates: 'dashboardChangeABDDates',
      dashboardChangeABDCaseOrigin: 'dashboardChangeABDCaseOrigin',
      loadRBD: 'loadRBD',
      dashboardChangeRBDDates: 'dashboardChangeRBDDates',
      dashboardChangeRBDCaseOrigin: 'dashboardChangeRBDCaseOrigin',
      loadCasesVsMaterials: 'loadCasesVsMaterials'
    }),
    async getMccLastUpdatedDate () {
      try {
        const lastUpdatedDate = await api.getLastUpdatedDate()
        if (lastUpdatedDate !== null) {
          this.lastUpdatedDate = moment(lastUpdatedDate).format('YYYY-MM-DD HH:mm:ss')
        }
      } catch (e) {
        console.log(e.message)
      }
    },
    handleActivityByDateChange (range) {
      this.dashboardChangeABDDates({
        fromDate: range[0],
        toDate: range[1]
      })
    },
    handleReportsByDateChange (range) {
      this.dashboardChangeRBDDates({
        fromDate: range[0],
        toDate: range[1]
      })
    }
  }
}
</script>

<style>
  .blue-th{
    color: #0D47A1!important;
  }
  .green-th{
    color: #1B5E20!important;
  }
  .list__tile__action .list__tile__action--select-multi{
    display: none;
  }
  .vertical-center{
    margin-bottom: auto;
    margin-top: auto;
  }

  .hold-status-text {
    color: #ffac26;
  }

  .filter-item {
    display: inline-block;
  }

  .origin-type-selector {
    width: 100px;
  }

  .date-picker-from {
    margin-right: 3px !important;
  }

  .date-picker-to {
    margin-left: 3px !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue